import { FaQuestionCircle } from 'react-icons/fa';
import { ContainerButtton } from './styles';
import { useTutorialVideo } from '../../hooks/useTutorialVideo';

const DuvidasButton = ({ tela }) => {
  const url = useTutorialVideo(tela);

  if (!url) return null;

  return (
    <ContainerButtton
      onClick={() => window.open(url, '_blank')}
      onMouseOver={(e) => (e.currentTarget.style.opacity = '0.8')}
      onMouseOut={(e) => (e.currentTarget.style.opacity = '1')}
      title="Dúvidas? Clique aqui para acessar nossos tutoriais em vídeo!"
    >
      <FaQuestionCircle size={16} />
    </ContainerButtton>
  );
};

export default DuvidasButton;
